import React from 'react';

const NexusLogo = () =>
  <img src="/Logo.svg" height={42} alt={'Rose Hospitality'} />

export default NexusLogo;
